const millisecondsToSeconds = (ms: number) => {
  if (typeof ms !== 'number') {
    return 0;
  }

  return ms / 1000;
};

export default millisecondsToSeconds;
